module.exports = __webpack_public_path__ + "img/less.4f173635.svg";